import { request } from '../request';

export const agentApi = {
  agentRoot: () => request('/agent/'),

  healthCheck: () => request('/agent/health'),

  agentApi: (body) =>
    request('/agent/process', {
      method: 'POST',
      body: JSON.stringify(body)
    }),

  getProcessStatus: () => request('/agent/admin/status'),

  shutdownSimple: () =>
    request('/agent/shutdown', {
      method: 'POST'
    }),

  shutdown: () =>
    request('/agent/admin/shutdown', {
      method: 'POST'
    }),

  getAgentRunningConfig: () => request('/agent/running-config'),

  updateAgentRunningConfig: (config) =>
    request('/agent/running-config', {
      method: 'PUT',
      body: JSON.stringify(config)
    }),

  getAgentLanguage: () => request('/agent/language'),

  updateAgentLanguage: (language) =>
    request('/agent/language', {
      method: 'PUT',
      body: JSON.stringify({ language })
    }),

  getUserTimezone: () => request('/config/user-timezone'),

  updateUserTimezone: (timezone) =>
    request('/config/user-timezone', {
      method: 'PUT',
      body: JSON.stringify({ timezone })
    })
};
